import { useCallback, useEffect, useState } from 'react';
import { ReleaseWhatsNewService } from './releaseWhatsNew.service';
import { ReleaseWhatsNewSlide } from './releaseWhatsNew.types';

export function useReleaseWhatsNew() {
  const [isOpen, setIsOpen] = useState(false);
  const [available, setAvailable] = useState(false);
  const [slides, setSlides] = useState<ReleaseWhatsNewSlide[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;

    ReleaseWhatsNewService.fetchStatus()
      .then((status) => {
        if (cancelled) {
          return;
        }
        setAvailable(status.available);
        setSlides(status.slides ?? []);
        if (status.showAuto && status.slides?.length) {
          setIsOpen(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setAvailable(false);
          setSlides([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoaded(true);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
    // Idempotent backup; auto-show slot is already consumed on GET /status.
    ReleaseWhatsNewService.dismiss().catch(() => {
      // Modal stays closed; next visit still won't auto-open if status was recorded.
    });
  }, []);

  const open = useCallback(() => {
    if (available && slides.length > 0) {
      setIsOpen(true);
    }
  }, [available, slides.length]);

  return { isOpen, available, slides, loaded, close, open };
}
